import React from 'react';
import './App.css'; 

const HomeRu = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.png" alt="Logo"/>
        <p className="centered-paragraph">
    Сёрфите в интернете на своих смарт-часах! Быстрый доступ к избранным. Повышайте свой опыт серфинга прямо сейчас с быстрым серфингом в интернете, умным поиском и бесперебойной связью для ваших смарт-часов. Наслаждайтесь плавным и эффективным серфингом прямо с вашего запястья!
</p>

        <a href='https://apps.apple.com/app/surfify-web-browser-on-watch/id6478813759?ppid=121505f9-a6b7-4285-b495-15bdd2bac71d'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
        </div>
        </>
     );
}
 
export default HomeRu;